<template>
  <div class="signup-complete-container">
    <FriedH2>{{ $t('welcome-to-getaccept') }}</FriedH2>
    <div v-if="showLoader" class="desktop-loading-info">
      <FriedSpinner />
      <FriedParagraph>{{
        $t('we-are-prepearing-your-account-and-you-will-be-redirected-in-a-few-seconds')
      }}</FriedParagraph>
    </div>
    <div v-else-if="popupBlocked" class="desktop-popup-blocked">
      <FriedParagraph>{{ $t('popup-is-blocked') }}</FriedParagraph>
      <FriedLink href="url" target="_blank">{{ $t('open-here') }}</FriedLink>
    </div>
    <FriedParagraph v-else>{{ $t('almost-there-please-check-your-inbox') }}</FriedParagraph>
  </div>
</template>

<script lang="ts">
import { isWindowSize } from '@getaccept/lib-shared-new/src/helpers/window-size.helper';
import { WindowSize } from '@getaccept/lib-shared-new/src/enums/window-size';
import { computed, defineComponent, onMounted, ref } from 'vue';
import { AfterSignStep } from '../../../types/enums/after-sign-step';
import { isPopupBlocked } from '../../../../common/utils/window';

export default defineComponent({
  props: {
    redirectUrl: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const isSmallScreen = ref(isWindowSize(WindowSize.XSmall));
    const url = ref('');
    const popupBlocked = ref(false);
    const redirectTimeout = 3000;
    const handleClose = () => {
      emit('close');
    };
    const showLoader = computed(() => isSmallScreen.value && !popupBlocked.value);
    onMounted(() => {
      if (!isSmallScreen.value) {
        const { href, pathname } = window.location;
        url.value = href.replace(pathname, `/${props.redirectUrl}`);
        setTimeout(() => {
          const newWindow: Window = window.open(url.value, '_blank');
          popupBlocked.value = isPopupBlocked(newWindow);
        }, redirectTimeout);
      }
    });
    return {
      isSmallScreen,
      url,
      popupBlocked,
      handleClose,
      showLoader,
      AfterSignStep,
    };
  },
});
</script>
<style lang="scss" scoped>
.signup-complete-container {
  text-align: center;

  .desktop-loading-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--spacing-100);
    padding: var(--spacing-100) 0;
  }
}
</style>
